module.exports = __webpack_public_path__ + "assets/Track-Note.e029a54c.svg";